module.exports = __webpack_public_path__ + "c9bd02d4173d127d228a0ffb9542cd68.jpg";